// extracted by mini-css-extract-plugin
export default {"contentHeader":"Programs_contentHeader__ilu7Y"};